import React from 'react';
import { CheckCircle2, Lock } from 'lucide-react';

/** Master agency A2P code used for direct signups (matches the API default). */
export const DEFAULT_A2P_PASSCODE = import.meta.env.VITE_A2P_DEFAULT_PASSCODE || 'CIVIX-10DLC-VERIFIED';

/**
 * Read-only, pre-embedded A2P 10DLC compliance field for signup. The code comes
 * from the invite (or the master agency profile) so agents never look one up.
 * @param {{passcode: string}} props
 * @returns {JSX.Element}
 */
export default function A2pCompliancePanel({ passcode }) {
  return (
    <div data-testid="a2p-compliance-panel">
      <label htmlFor="a2p-passcode" className="text-xs uppercase tracking-wider text-white/50 font-medium">
        A2P Compliance Passcode
      </label>
      <div className="relative mt-1.5">
        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40 pointer-events-none" />
        <input
          id="a2p-passcode"
          type="text"
          value={passcode}
          readOnly
          tabIndex={-1}
          aria-readonly="true"
          className="w-full pl-10 pr-10 py-2.5 rounded-lg bg-white/5 border border-emerald-500/30 text-sm font-mono text-white/80 cursor-not-allowed outline-hidden"
        />
        <CheckCircle2 className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-emerald-400 pointer-events-none" />
      </div>
      <div className="mt-2 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-medium bg-emerald-500/15 text-emerald-400 border border-emerald-500/30">
        <CheckCircle2 className="w-3.5 h-3.5" />
        Verified CIVIX LLC Compliance Profile Attached
      </div>
      <div className="text-[11px] text-white/40 mt-1.5">
        Pre-authorized under CIVIX LLC. Your outbound line will be automatically registered for carrier compliance and SHAKEN/STIR attestation upon activation.
      </div>
    </div>
  );
}
